export default {
  components: {
    fitWorkflowProgress: {
      next: '下一步',
      previous: '上一步'
    },

    FITFileUpload: {
      select: '選擇文件',
      upload: '上傳文件',
      fileName: '文件名',
      size: '文件容量',
      publicDocument: '公開文件',
      isPublic: '公開',
      documentTag: '標籤',
      remarks: '備註',
      isDownloadable: '可供下載',
      remove: '刪除',
      dropFileMsg: '拉動文件至此用於上傳',
      uploadRemindMsg: '請務必於選擇文件完成後點選“上傳文件”',
      successMsg: '您的文件已成功上傳。',
      errorMsg: '您的文件上傳失敗，請稍候再試'
    },
    FITOutstandingRequirement: {
      general: {
        ID: '編號',
        type: '種類',
        clientID: '客戶編號',
        submitBtn: '提交',
        lastUpdate: '最後更新',
        replys: '回覆',
        createAgent: '創建顧問',
        createTime: '創建日期',
        updateTime: '更新日期',
        subject: '主題',
        status: '狀態',
        caseID: '檔案編號',
        caseActionPrefix: '確認',
        caseActionPostfix: '此附加要求',
        fileDownloadErrorMsg: ' 請允許瀏覽器“彈出窗口”用於文件下載',
      },
      createCase: {
        title: '創建檔案',
        header: '創建附加要求',
        description: '內容',
        confirmMsg: '確認創建此附加要求？',
        errorMsg: '創建附加要求失敗，請稍候再試。',
      },
      caseHistory: {
        title: '檔案列表',
        header: '附加要求列表',
        createBtn: '創建檔案',
        noDataMsg: '無附加要求記錄',
      },
      caseDetail: {
        title: '檔案詳情',
        header: '附加要求詳情',
        errorMsg: '回覆失敗，請稍候再試',
        information: '詳情',
        correspondence: '回應',
        documents: '文檔列表',
        comfirmReplyMsg: '確認提交此回覆？',
        replyBtn: '回復',
        closeBtn: '關閉',
        acceptBtn: '批准',
        rejectBtn: '拒絕',



      },
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/langs/zh_hk/index.js